// //loader added to gstbill button
// import React, { useEffect, useRef, useState } from 'react';
// import './GstBillsData.css';
// import * as XLSX from 'xlsx';
// import { useMain } from 'src/views/hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { Grid } from 'rsuite';
// import { Button, IconButton, InputLabel, MenuItem, Pagination, Select } from '@mui/material';
// import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
// import { Box } from '@mui/system';
// import SearchImg from '../../../assets/search.svg';
// import { FaDownload } from "react-icons/fa";
// import { MdClear } from "react-icons/md";

// const GstBillsPage = () => {
//   const [tableData, setTableData] = useState([]);
//   const [filterData, setFilterData] = useState([]);
//     const [fullFilteredData, setFullFilteredData] = useState([]); // For Excel download
//   const [isTableVisible, setIsTableVisible] = useState(false);
//   const [search, setSearch] = useState('');
//   const [genderBy, setGenderBy] = useState('');
//   const [limit, setLimit] = useState(10);
//   const [page, setPage] = useState(1);
//   const [clear, setClear] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [totalPages, setTotalPages] = useState(1);
//   const [downloading, setDownloading] = useState(false);

//   const { activeBranchId, getGstData } = useMain();
//   const pdfRef = useRef();
 
//   // Fetch GST Bill Details
//   const fetchGstBillDetails = async () => {
//     setLoading(true);
//     try {
//       const res = await getGstData(activeBranchId);
//       if (res && res.data && res.data.bills) {
//         setTableData(res.data.bills);
//         setFilterData(res.data.bills); // Set initial filterData
//         setFullFilteredData(res.data.bills); // Set initial full data
//         setIsTableVisible(true);
//       } else {
//         console.error('Invalid response structure:', res);
//       }
//     } catch (error) {
//       console.error('Error fetching API:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//    const fullFilteredDataRef = useRef([]);

//   useEffect(() => {
//     const { paginatedData, fullFilteredData } = applyFilters();
//     setFilterData(paginatedData);
//     fullFilteredDataRef.current = fullFilteredData;
//   }, [tableData, limit, genderBy, page, search, startDate, endDate]);

//   const applyFilters = () => {
//     let filteredData = tableData.filter((item) => {
//       let isGenderMatch = true;
//       let isNameMatch = true;
//       let isDateMatch = true;

//       if (genderBy) {
//         isGenderMatch = item.gender === genderBy;
//       }

//       if (search) {
//         const clientName = item.clientName || '';
//         const clientNumber = item.clientNumber || '';
//         isNameMatch =
//           clientName.toLowerCase().includes(search.toLowerCase()) ||
//           clientNumber.includes(search);
//       }

//       if (startDate && endDate) {
//         const billDate = new Date(item.dateOfBilling);
//         isDateMatch =
//           billDate >= new Date(startDate) &&
//           billDate <= new Date(endDate);
//       }

//       return isGenderMatch && isNameMatch && isDateMatch;
//     });

//     const fullFilteredData = [...filteredData];

//     // Calculate total pages based on filtered data
//     const calculatedPages = Math.ceil(filteredData.length / limit);
//     setTotalPages(calculatedPages || 1); // Ensure at least 1 page

//     // Store full filtered data for Excel download
//     setFullFilteredData(filteredData);

//     // Apply pagination for UI display for table view
//     const startIndex = (page - 1) * limit;
//     const endIndex = startIndex + limit;
//     const paginatedData = filteredData.slice(startIndex, endIndex);

//     return { paginatedData, fullFilteredData };
//   };

//   const handleDateRangeSelected = (startDate, endDate) => {
//     setStartDate(startDate);
//     setEndDate(endDate);
//     setIsModalOpen(false);
//     setClear(true);
//   };

//   const clearDataHandler = () => {
//     setLimit(10);
//     setPage(1);
//     setSearch('');
//     setGenderBy('');
//     setEndDate('');
//     setStartDate('');
//     setClear(false);
//     fetchGstBillDetails(); // Re-fetch all data when cleared
//   };


//   const downloadExcel = () => {
//     setDownloading(true);
//     setTimeout(() => {
//       const dataToDownload =
//         startDate && endDate
//           ? fullFilteredDataRef.current // all filtered data for date range
//           : filterData; // only paginated data

//       const dataForExcel = dataToDownload.map((item) => {
//         const originalDate = item?.dateOfBilling || '';
//         let formattedBillDate = '';
//         if (originalDate) {
//           const [year, month, day] = originalDate.split('-');
//           formattedBillDate = `${day}-${month}-${year}`;
//         }

//         return {
//           'Date': formattedBillDate,
//           'Client Name': item.clientName || '',
//           'Invoice No': item.invoice || '',
//           'Amount': item.subTotal || '',
//           'Payable Amount': item.amountPayable || '',
//           'Gst Fair Amount': (item.amountPayable - item.subTotal) || '',
//         };
//       });

//       const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
//       const workbook = XLSX.utils.book_new();

//       XLSX.utils.book_append_sheet(workbook, worksheet, 'GST_Bills');

//       if (startDate && endDate) {
//         XLSX.utils.sheet_add_aoa(worksheet, [[`Date Range: ${startDate} to ${endDate}`]], { origin: 'A1' });
//       }

//       XLSX.writeFile(workbook, 'GST_Bill_Details.xlsx');
//       setDownloading(false);
//     }, 100);
//   };

//    const handleLimitChange = (e) => {
//     setLimit(e.target.value);
//     setPage(1);
//   };

//   // Only fetch data on component mount
//    useEffect(() => {
//     fetchGstBillDetails();
//   }, [activeBranchId]);

//   return (
//     <>
//       <div>
//         {loading ? (
//           <ShowLoader />
//         ) : (
//           <>
//             {isTableVisible && (
//               <>
//                 <div className="dateInput-container">
//                   <Grid item xs={2}>
//                     <InputLabel>Show per page</InputLabel>
//                     <Select
//                       style={{
//                         borderRadius: '7px',
//                         border: '0.5px solid #6174DD',
//                         padding: '4px 12px',
//                         background: '#FFF',
//                         height: '40px',
//                       }}
//                       value={limit}
//                       onChange={handleLimitChange}
//                     >
//                       {[10, 20, 50].map((value) => (
//                         <MenuItem key={value} value={value}>
//                           {value}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </Grid>

//                   <Grid
//                     item
//                     xs={2}
//                     display={'flex'}
//                     flexDirection={'column'}
//                     justifyContent={'flex-end'}
//                   >
//                     <div style={{ flex: '1 1 150px' }}>
//                       <Button
//                         variant="outlined"
//                         sx={{
//                           color: 'black',
//                           height: '40px',
//                           // width: startDate && endDate ? '100%' : '60%', // Use full width when dates are selected
//                           width: startDate && endDate ? '240px' : '150px', // Use full width when dates are selected
//                           marginTop: '0.4rem',
//                           // marginBottom: '0.3rem',
//                           marginLeft: startDate && endDate ? '-16rem' : '-19rem', // Adjust margin based on date selection
//                           display: 'flex',
//                           justifyContent: startDate && endDate ? 'space-between' : 'center',
//                           padding: '0 8px',
//                           whiteSpace: 'nowrap', // Prevent text wrapping
//                           overflow: 'hidden', // Hide overflow
//                           textOverflow: 'ellipsis', // Add ellipsis for overflow text
//                           marginRight: '18rem',
//                           marginBottom: '-1.3rem',
//                         }}
//                         onClick={() => setIsModalOpen(true)}
//                       >
//                         {startDate && endDate ? (
//                           <>
//                             <span>{`${startDate} to ${endDate}`}</span>
//                             <IconButton
//                               size="small"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setStartDate('');
//                                 setEndDate('');
//                                 setClear(false);
//                                 applyFilters();
//                               }}
//                               sx={{
//                                 padding: 0,
//                                 '&:hover': {
//                                   backgroundColor: 'transparent',
//                                 },
//                               }}
//                             >
//                               <MdClear style={{ color: '#000', height: '1rem' }} />
//                             </IconButton>
//                           </>
//                         ) : (
//                           'Choose Date'
//                         )}
//                       </Button>
//                     </div>
//                   </Grid>

//                   <Grid item xs={2} style={{ width: '15rem', marginRight: '-0.2rem' }}>
//                     <div style={{ marginLeft: '6.3rem' }}>
//                       <InputLabel>Search</InputLabel>
//                       <div className="search-input">
//                         <img src={SearchImg} alt="" />
//                         <input
//                           type="text"
//                           placeholder=""
//                           value={search}
//                           onChange={(e) => setSearch(e.target.value)}
//                         />
//                         {search && (
//                           <IconButton
//                             onClick={() => {
//                               setSearch('');
//                               setClear(false);
//                             }}
//                             style={{ padding: 1 }}
//                           >
//                             <MdClear style={{
//                               // color: '#ff4d4d',
//                               color: '#000',
//                               // color: '#A2A3AE',
//                               marginRight: '-0.2rem', marginTop: '0.1rem',
//                               fontSize: '1.1rem'
//                             }} />
//                           </IconButton>
//                         )}
//                       </div>
//                     </div>
//                   </Grid>

//                   {/* <Grid item xs={2} display="flex" gap="20px" alignItems="flex-end">
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       sx={{
//                         height: '40px',
//                         marginTop: '1.7rem',
//                         width: '100%',
//                         background: '#ff4d4d',
//                         '&:hover': { background: '#ff6666' },
//                       }}
//                       onClick={clearDataHandler}
//                     >
//                       Clear
//                     </Button>
//                   </Grid> */}
//                 </div>

//                 <DateRangeInputs
//                   isOpen={isModalOpen}
//                   onClose={() => setIsModalOpen(false)}
//                   onDateRangeSelected={handleDateRangeSelected}
//                   selectedEndDate={endDate}
//                   selectedStartDate={startDate}
//                 />

//                 <div className="gst-table-container" ref={pdfRef}>
//                   <table>
//                     <thead>
//                       <tr>
//                         {/*<th colSpan="7" style={{ textAlign: 'right' }}>
//                           <CloseIcon onClick={closeTable} style={{ cursor: 'pointer' }} />
//                         </th>*/}
//                       </tr>
//                       <tr>
//                         <th>Date</th>
//                         <th>Client Name</th>
//                         <th>Invoice No</th>
//                         <th>Amount</th>
//                         <th>Payable Amount</th>
//                         <th>Gst Fair Amount</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filterData.map((item) => {
//                         const originalDate = item?.dateOfBilling;
//                         let formattedBillDate = '';
//                         if (originalDate) {
//                           const [year, month, day] = originalDate.split('-');
//                           formattedBillDate = `${day}-${month}-${year}`;
//                         }
//                         return (
//                           <tr key={item._id}>
//                             <td>{formattedBillDate}</td>
//                             <td>{item.clientName}</td>
//                             <td>{item.invoice}</td>
//                             <td>{item.subTotal}</td>
//                             <td>{item.amountPayable}</td>
//                             <td>{item.amountPayable - item.subTotal}</td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="download-pdf">
//                   {/* <button onClick={downloadPdf}>Download PDF</button> */}
//                   <button title="Download Bills" onClick={downloadExcel}><FaDownload style={{ height: "1.6rem", fontSize: "1.2rem" }} /></button>
//                 </div>

             
//                 <Box display="flex" justifyContent="center" mt={2}>
//                   <Pagination
//                     count={totalPages}
//                     page={page}
//                     onChange={(event, value) => setPage(value)}
//                     color="primary"
//                   />
//                 </Box>
//               </>
//             )}
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// export default GstBillsPage;

import React, { useEffect, useRef, useState, useCallback } from 'react';
import './GstBillsData.css';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { useNavigate } from 'react-router-dom';
import { useMain } from 'src/views/hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import CloseIcon from '@mui/icons-material/Close';
import { Grid } from 'rsuite';
import { Button, IconButton, InputLabel, MenuItem, Pagination, Select, Typography } from '@mui/material';
import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
import { Box } from '@mui/system';
import { FaDownload, FaFileExcel, FaFilePdf } from "react-icons/fa";
import SearchImg from '../../../assets/search.svg';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import BigFilter from 'src/components/inputs/BigFilter';

const GstBillsPage = () => {
  const [tableData, setTableData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [fullFilteredData, setFullFilteredData] = useState([]);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [search, setSearch] = useState('');
  const [genderBy, setGenderBy] = useState('');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [clear, setClear] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [downloading, setDownloading] = useState(false);
  const [checkedBills, setCheckedBills] = useState([]); // State for selected bills
  const [isAllChecked, setIsAllChecked] = useState(false); // State for select all checkbox
  const [hideDownloadButton, setHideDownloadButton] = useState(true);

  const navigate = useNavigate();
  const { activeBranchId, getGstData, branchData, setShowMessage , getBranch } = useMain();
  const pdfRef = useRef();
useEffect(() => {
  if (!activeBranchId) return;
  const fetchHideDownload = async () => {
    try {
      const res = await getBranch(activeBranchId);
      setHideDownloadButton(res?.data?.hideDownloadButton || false);
    } catch (error) {
      console.error("Error fetching branch data:", error);
    }
  };
  fetchHideDownload();
}, [activeBranchId]);
  useEffect(() => {
  if (branchData) {
    setHideDownloadButton(branchData.hideDownloadButton || false);
  }
}, [branchData]);
  // Reset checked states whenever the data or filters change
  const resetCheckedStates = useCallback(() => {
    setCheckedBills([]);
    setIsAllChecked(false);
  }, []);

  // Handle "select all" checkbox change
  const handleSelectAll = (event) => {
    setIsAllChecked(event.target.checked);
    if (event.target.checked) {
      // If "select all" is checked, add all filtered data IDs to checkedBills
      const allBillIds = fullFilteredData.map((item) => item._id);
      setCheckedBills(allBillIds);
    } else {
      setCheckedBills([]); // Clear all selections
    }
  };

  // Handle individual checkbox change
  const handleSelectOne = (event, id) => {
    const { checked } = event.target;
    if (checked) {
      setCheckedBills((prev) => [...prev, id]);
    } else {
      setCheckedBills((prev) => prev.filter((billId) => billId !== id));
    }
  };

  useEffect(() => {
    // Update "select all" checkbox based on individual selections
    if (fullFilteredData.length > 0 && checkedBills.length === fullFilteredData.length) {
      setIsAllChecked(true);
    } else {
      setIsAllChecked(false);
    }
  }, [checkedBills, fullFilteredData]);

  useEffect(() => {
    resetCheckedStates();
  }, [filterData, resetCheckedStates]);

  // Fetch GST Bill Details
  const fetchGstBillDetails = async () => {
    setLoading(true);
    try {
      const res = await getGstData(activeBranchId);
      if (res && res.data && res.data.bills) {
        setTableData(res.data.bills);
        setFilterData(res.data.bills);
        setFullFilteredData(res.data.bills);
        setIsTableVisible(true);
      } else {
        console.error('Invalid response structure:', res);
      }
    } catch (error) {
      console.error('Error fetching API:', error);
    } finally {
      setLoading(false);
    }
  };

  const fullFilteredDataRef = useRef([]);

  useEffect(() => {
    const { paginatedData, fullFilteredData } = applyFilters();
    setFilterData(paginatedData);
    fullFilteredDataRef.current = fullFilteredData;
  }, [tableData, limit, genderBy, page, search, startDate, endDate]);

  const applyFilters = () => {
    let filteredData = tableData.filter((item) => {
      let isGenderMatch = true;
      let isNameMatch = true;
      let isDateMatch = true;

      if (genderBy) {
        isGenderMatch = item.gender === genderBy;
      }

      if (search) {
        const clientName = item.clientName || '';
        const clientNumber = item.clientNumber || '';
        isNameMatch =
          clientName.toLowerCase().includes(search.toLowerCase()) ||
          clientNumber.includes(search);
      }

      if (startDate && endDate) {
        const billDate = new Date(item.dateOfBilling);
        isDateMatch =
          billDate >= new Date(startDate) &&
          billDate <= new Date(endDate);
      }

      return isGenderMatch && isNameMatch && isDateMatch;
    });

    const fullFilteredData = [...filteredData];
    const calculatedPages = Math.ceil(filteredData.length / limit);
    setTotalPages(calculatedPages || 1);

    setFullFilteredData(filteredData);

    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    return { paginatedData, fullFilteredData };
  };

  const handleFilterChange = (selectedValues) => {
    setGenderBy(selectedValues[0] || '');
    setPage(1);
  };

  const handleDateRangeSelected = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
    setPage(1);
  };

  const clearDataHandler = () => {
    setLimit(10);
    setPage(1);
    setSearch('');
    setGenderBy('');
    setEndDate('');
    setStartDate('');
    setClear(false);
    fetchGstBillDetails();
  };

//   const downloadPdf = () => {
//     if (checkedBills.length === 0) {
//       setShowMessage({ message: 'No bills selected for bulk PDF download. Downloading current page.', messageType: 'info' });
//       const input = pdfRef.current;
//       html2canvas(input).then((canvas) => {
//         const imgData = canvas.toDataURL('image/png');
//         const pdf = new jsPDF('p', 'mm', 'a4');
//         const imgWidth = 190;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;
//         pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
//         pdf.save('GST_Bill_Details_current_page.pdf');
//       });
//       return;
//     }

//     setShowMessage({ message: `Generating PDF for ${checkedBills.length} selected bills...`, messageType: 'info' });

//     const selectedBillObjects = fullFilteredData.filter(bill => checkedBills.includes(bill._id));

//     const doc = new jsPDF();
//     doc.text("GST Bill Details - Selected Bills", 14, 16);

//     const tableColumn = [
//       "Date", "Client Name", "Invoice No", "Taxable Amount",
//       "SGST", "CGST", "Total GST Amount", "Payable Amount"
//     ];
//     const tableRows = [];

//     selectedBillObjects.forEach(item => {
//       const originalDate = item?.dateOfBilling || '';
//       let formattedBillDate = '';
//       if (originalDate) {
//         const [year, month, day] = originalDate.split('-');
//         formattedBillDate = `${day}-${month}-${year}`;
//       }
//       const billData = [
//         formattedBillDate,
//         item.clientName || '',
//         item.invoice || '',
//         item.subTotal || '',
//         item.sgst || 0,
//         item.cgst || 0,
//         (item.amountPayable - item.subTotal) || 0,
//         item.amountPayable || '',
//       ];
//       tableRows.push(billData);
//     });

//     doc.autoTable(tableColumn, tableRows, { startY: 20 });
//     doc.save(`GST_Bill_Details_selected_${checkedBills.length}.pdf`);
//     setShowMessage({ message: `PDF generated successfully for ${checkedBills.length} bills.`, messageType: 'success' });
//   };

//   const downloadExcel = () => {
//     if (checkedBills.length === 0) {
//       setShowMessage({ message: 'No bills selected for bulk Excel download. Downloading all filtered data.', messageType: 'info' });
//       setDownloading(true);
//       setTimeout(() => {
//         const dataToDownload =
//           startDate && endDate
//             ? fullFilteredDataRef.current
//             : fullFilteredData; // Changed filterData to fullFilteredData for consistency in bulk

//         const dataForExcel = dataToDownload.map((item) => {
//           const originalDate = item?.dateOfBilling || '';
//           let formattedBillDate = '';
//           if (originalDate) {
//             const [year, month, day] = originalDate.split('-');
//             formattedBillDate = `${day}-${month}-${year}`;
//           }

//           return {
//             'Date': formattedBillDate,
//             'Client Name': item.clientName || '',
//             'Invoice No': item.invoice || '',
//             'Taxable Amount': item.subTotal || '',
//             'SGST': item.sgst || 0,
//             'CGST': item.cgst || 0,
//             'Gst Fair Amount': (item.amountPayable - item.subTotal) || '',
//             'Payable Amount': item.amountPayable || '',
//           };
//         });

//         const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
//         const workbook = XLSX.utils.book_new();

//         XLSX.utils.book_append_sheet(workbook, worksheet, 'GST_Bills');

//         if (startDate && endDate) {
//           XLSX.utils.sheet_add_aoa(worksheet, [[`Date Range: ${startDate} to ${endDate}`]], { origin: 'A1' });
//         }

//         XLSX.writeFile(workbook, 'GST_Bill_Details.xlsx');
//         setDownloading(false);
//         setShowMessage({ message: 'Excel downloaded successfully for all filtered data.', messageType: 'success' });
//       }, 100);
//       return;
//     }

//     setShowMessage({ message: `Generating Excel for ${checkedBills.length} selected bills...`, messageType: 'info' });
//     setDownloading(true);
//     setTimeout(() => {
//       const selectedBillObjects = fullFilteredData.filter(bill => checkedBills.includes(bill._id));

//       const dataForExcel = selectedBillObjects.map((item) => {
//         const originalDate = item?.dateOfBilling || '';
//         let formattedBillDate = '';
//         if (originalDate) {
//           const [year, month, day] = originalDate.split('-');
//           formattedBillDate = `${day}-${month}-${year}`;
//         }

//         return {
//           'Date': formattedBillDate,
//           'Client Name': item.clientName || '',
//           'Invoice No': item.invoice || '',
//           'Taxable Amount': item.subTotal || '',
//           'SGST': item.sgst || 0,
//           'CGST': item.cgst || 0,
//           'Gst Fair Amount': (item.amountPayable - item.subTotal) || '',
//           'Payable Amount': item.amountPayable || '',
//         };
//       });

//       const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
//       const workbook = XLSX.utils.book_new();

//       XLSX.utils.book_append_sheet(workbook, worksheet, 'GST_Bills_Selected');
//       XLSX.writeFile(workbook, `GST_Bill_Details_selected_${checkedBills.length}.xlsx`);
//       setDownloading(false);
//       setShowMessage({ message: `Excel downloaded successfully for ${checkedBills.length} selected bills.`, messageType: 'success' });
//     }, 100);
//   };
const handleDownloadBulkPdf = () => {
  if (checkedBills.length === 0) {
    setShowMessage({ message: 'No bills selected for bulk PDF download.', messageType: 'error' });
    return;
  }

  const billIds = checkedBills; // checkedBills already stores _id values in your file

  navigate('/bulkbillgenerator', {
    state: {
      billIds,
      billType: 'Bill', // change if you track billType separately, else hardcode like AllBillings does for non-Wallet
    },
  });
};
const handleOnExport = () => {
  const exportData = startDate && endDate ? fullFilteredData : tableData;
  if (!Array.isArray(exportData)) return;

  const dataForExcel = exportData.map((item) => {
    const originalDate = item?.dateOfBilling || '';
    let formattedBillDate = '';
    if (originalDate) {
      const [year, month, day] = originalDate.split('-');
      formattedBillDate = `${day}-${month}-${year}`;
    }
    return {
      'Date': formattedBillDate,
      'Client Name': item.clientName || '',
      'Invoice No': item.invoice || '',
      'Taxable Amount': item.subTotal || '',
      'SGST': item.sgst || 0,
      'CGST': item.cgst || 0,
      'Gst Fair Amount': (item.amountPayable - item.subTotal) || '',
      'Payable Amount': item.amountPayable || '',
    };
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(dataForExcel);
  XLSX.utils.book_append_sheet(wb, ws, 'GST_Bills');
  XLSX.writeFile(wb, 'GST_Bills.xlsx');
};
  const handleDownloadBill = (item) => {
    const billType = item?.billType;
    const id = item?._id;
    // Use ownerId from branchData
    const ownerId = branchData?.ownerId?.[0]?._id;

    if (billType === 'Package' || billType === 'Membership') {
      navigate(`/billing/${id}`, {
        state: { ownerId, billType: billType.toLowerCase() },
      });
    } else {
      navigate(`/billing/${id}`, { state: { ownerId } });
    }
  };
// Fixed column widths for GST table (checkbox gets a small fixed width, rest share evenly)
  const gstGridTemplate = '30px 1fr 1fr 1fr 1fr 0.6fr 0.6fr 1fr 1fr 0.6fr';

  const gridRowStyle = {
    display: 'grid',
    gridTemplateColumns: gstGridTemplate,
    alignItems: 'center',
    columnGap: '10px',
  };
  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    fetchGstBillDetails();
  }, [activeBranchId]);



  return (
   <>
  <div>
    {loading ? (
      <ShowLoader />
    ) : (
      <>
        {isTableVisible && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '1rem' }}>
              {/* Show per page - Left side */}
              <div >
                <InputLabel>Show per page</InputLabel>
                <Select
                  style={{
                    borderRadius: '7px',
                    border: '0.5px solid #6174DD',
                    padding: '4px 12px',
                    background: '#FFF',
                    height: '40px',
                  }}
                  value={limit}
                  onChange={handleLimitChange}
                >
                  {[10, 20, 50].map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                  <MenuItem value={1000000}>All</MenuItem>
                </Select>
              </div>

              {/* Filter and Search - Right side with 0.8rem gap */}
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.8rem' }}>

                {/* Search */}
                <div style={{ width: '8.5rem' }}>
                  <InputLabel>Search</InputLabel>
                  <div className="search-input">
                    <img src={SearchImg} alt="" />
                    <input
                      type="text"
                      placeholder="Search by name or number"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                      }}
                    />

                    {search && (
                      <IconButton
                        onClick={() => {
                          setSearch('');
                          setClear(false);
                        }}
                        style={{ padding: 1 }}
                      >
                        <ClearIcon style={{
                          color: '#000',
                          marginRight: '-0.1rem',
                          marginTop: '0.1rem',
                          fontSize: '1.1rem'
                        }} />
                      </IconButton>
                    )}
                  </div>
                </div>

                {/* Filter */}
                <div>
                  <BigFilter
                    options={[
                      // {
                      //   title: 'Gender',
                      //   items: [
                      //     { value: 'Female', label: 'Female' },
                      //     { value: 'Male', label: 'Male' }
                      //   ]
                      // }
                    ]}
                    value={genderBy ? [genderBy] : []}
                    onChange={handleFilterChange}
                    showDateRange={true}
                    onDateRangeSelected={handleDateRangeSelected}
                    selectedStartDate={startDate}
                    selectedEndDate={endDate}
                    placeholder="Filters"
                  />
                </div>
                {/* Download Buttons */}
                {!hideDownloadButton && (
  <div style={{ width: 'auto' }}>
    <Button
      variant="contained"
      color="primary"
      title="Bulk Download Bill PDF"
      sx={{
        height: '40px',
        padding: '0.3rem 1rem',
        '&:hover': { background: '#6174DD' },
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
      }}
      onClick={handleDownloadBulkPdf}
    >
      <FaDownload style={{ fontSize: '1.2rem' }} />
      PDF
    </Button>
  </div>
)}

{/* Bulk Excel Download Button */}
{!hideDownloadButton && (
  <div style={{ width: 'auto' }}>
    <Button
      variant="contained"
      color="primary"
      title="Download Bills"
      sx={{
        height: '40px',
        padding: '0.3rem 1rem',
        '&:hover': { background: '#6174DD' },
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
      }}
      onClick={handleOnExport}
    >
      <FaDownload style={{ fontSize: '1.2rem' }} />
      Excel
    </Button>
  </div>
)}
 
              </div>
            </div>

            <Box sx={{ overflow: 'auto', width: '100%' }}>
              <table className="table-container mt-3" ref={pdfRef}>
             <thead className="table-thead">
  <tr style={gridRowStyle}>
    <th>
      <input
        type="checkbox"
        checked={isAllChecked}
        onChange={handleSelectAll}
      />
    </th>
    <th style={{ textAlign: 'center' }}>Date</th>
    <th style={{ textAlign: 'center' }}>Client Name</th>
    <th style={{ textAlign: 'center' }}>Invoice No</th>
    <th style={{ textAlign: 'center' }}>Taxable Amount</th>
    <th style={{ textAlign: 'center' }}>SGST</th>
    <th style={{ textAlign: 'center' }}>CGST</th>
    <th style={{ textAlign: 'center' }}>Total Gst Amount</th>
    <th style={{ textAlign: 'center' }}>Payable Amount</th>
    <th style={{ textAlign: 'center' }}>Action</th>
  </tr>
</thead>
      <tbody className="table-tbody">
  {filterData.map((item) => {
    const originalDate = item?.dateOfBilling;
    let formattedBillDate = '';
    if (originalDate) {
      const [year, month, day] = originalDate.split('-');
      formattedBillDate = `${day}-${month}-${year}`;
    }
    return (
      <tr key={item._id} style={gridRowStyle}>
        <td>
          <input
            type="checkbox"
            checked={checkedBills.includes(item._id)}
            onChange={(event) => handleSelectOne(event, item._id)}
          />
        </td>
        <td style={{ textAlign: 'center' }}>{formattedBillDate}</td>
        <td style={{ textAlign: 'center' }}>{item.clientName}</td>
        <td style={{ textAlign: 'center' }}>{item.invoice}</td>
        <td style={{ textAlign: 'center' }}>{item.subTotal}</td>
        <td style={{ textAlign: 'center' }}>{item.sgst || 0}</td>
        <td style={{ textAlign: 'center' }}>{item.cgst || 0}</td>
        <td style={{ textAlign: 'center' }}>{item.amountPayable - item.subTotal}</td>
        <td style={{ textAlign: 'center' }}>{item.amountPayable}</td>
        <td style={{ textAlign: 'center' }}>
          <IconButton
            onClick={() => handleDownloadBill(item)}
            sx={{ color: '#6174DD' }}
            title="Download Bill"
          >
            <FaDownload style={{ fontSize: '1.2rem' }} />
          </IconButton>
        </td>
      </tr>
    );
  })}
</tbody>
              </table>
            </Box>

            <Box display="flex" justifyContent="center" mt={2}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(event, value) => setPage(value)}
                color="primary"
              />
            </Box>

          </>
        )}
      </>
    )}
  </div>
</>
  );
};

export default GstBillsPage;